import React from 'react';
import { View } from 'react-native';

import ReactSvgPieChart from 'react-svg-piechart';
import { COLOR } from '../constants/styles';

module.exports = {
  PieChart: (props) => {
    const { style, data } = props;
    if (!data || Object.keys(data).length < 1) return null;
    return (
      <View style={style}>
        <ReactSvgPieChart viewBoxSize={style.height} data={data} />
        {/* overlay white circle to match designs */}
        <View
          style={{
            position: 'absolute',
            backgroundColor: COLOR.contrast,
            height: 90,
            width: 90,
            left: 45,
            top: 45,
            borderRadius: 100,
          }}
        />
      </View>
    );
  },
};
